import { render, staticRenderFns } from "./DatosPlantilla.vue?vue&type=template&id=0be43040&lang=pug&"
import script from "./DatosPlantilla.vue?vue&type=script&lang=js&"
export * from "./DatosPlantilla.vue?vue&type=script&lang=js&"
import style0 from "./DatosPlantilla.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports